'use client';

import { OfferDocument } from 'models/offer';
import { useOffers } from '../useOffers';
import { useToastContext } from 'context/ToastContext';

interface DeclineOfferContentProps {
  offer: OfferDocument;
  onClose: () => void;
}

export default function DeclineOfferContent({
  offer,
  onClose,
}: DeclineOfferContentProps) {
  const { declineThatOffer } = useOffers(offer.id);
  const { showErrorToast } = useToastContext();

  return (
    <>
      <div className="mt-8 flex w-full items-center justify-center p-8">
        <h3 className="w-[40rem] text-center text-[2rem] text-zinc-800">
          Are you sure want to decline this offer? You can&apos;t undo this
          action.
        </h3>
      </div>

      <div className="mt-10 flex w-full flex-col items-center justify-center bg-brand-lightest-gray p-12">
        <div className="flex w-full items-center gap-x-8">
          <button
            type="button"
            className="flex w-full items-center justify-center rounded-[1.5rem] border border-brand-black bg-inherit p-4 text-[1.8rem] font-semibold text-brand-black"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            type="button"
            className="flex w-full items-center justify-center rounded-[1.5rem] bg-[#C41719] p-4 text-[1.8rem] font-semibold text-white"
            onClick={async () => {
              try {
                await declineThatOffer();
                onClose();
              } catch (e) {
                showErrorToast((e as Error).message);
              }
            }}
          >
            Decline
          </button>
        </div>
      </div>
    </>
  );
}
